import styled from 'styled-components';

export const TileContentContainer = styled.div`
  width: 100%;
  padding: 30px 40px;
  margin: 35px auto 0 auto;
`;

export const ItemBreakdownContainer = styled.div`
  margin-bottom: 15px;
`;
